import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { ThemeSelector } from '../components';

const Head = styled.div`
  display: flex;
  height: 50px;
  background: #eceef1;
  border-bottom: 2px solid #cacfd9;
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 5px;
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px;
`;

const ThemeBar = ({ theme, selectTheme, selectedTheme }) => (
  <ThemeProvider theme={theme}>
    <div>
      <Head>
        <Left>Coinmend Assets</Left>
        <Right>
          <ThemeSelector selectTheme={selectTheme} selectedTheme={selectedTheme} />
        </Right>
      </Head>
    </div>
  </ThemeProvider>
);

export default withTheme(ThemeBar);



// WEBPACK FOOTER //
// ./src/components/ThemeBar.js